import React from 'react'

import ItemWrapper from '../ItemWrapper'
import MusicOptions from '../../../MusicOptions'

import type { AudioGlobalMetadata } from '@/hooks/audio/store'

import MusicProfile from '@/components/MusicProfile'
import { useInWhichPage } from '@/hooks/useInWhichPage'

export type MusicMetadataError = {
  status: 'error'
  allowRetry: boolean
  message?: string | null
  taskId: number
} & Pick<AudioGlobalMetadata, 'id' | 'title' | 'musicType'>

export interface MusicItemErrorProps {
  data: MusicMetadataError
  onRetry: () => Promise<void>
  onDeleted?: () => void
}

const MusicItemError: React.FC<MusicItemErrorProps> = (props) => {
  const { data, onRetry, onDeleted } = props
  const { shouldShowMusicTagLabel } = useInWhichPage()
  return (
    <ItemWrapper>
      <MusicProfile
        {...(shouldShowMusicTagLabel ? { showTagLabel: true } : {})}
        data={data}
        cover={{
          className: 'hidden xl:block',
        }}
        showTypes={['error']}
        errorMessage={data.message}
      />
      <MusicOptions
        data={data as any}
        expand={[{ key: 'delete', iconOnly: true }]}
        onlyExpand
        error={{
          allowRetry: data.allowRetry,
          message: data.message || 'Unknown error',
          onRetry,
        }}
        onDeleted={onDeleted}
      />
    </ItemWrapper>
  )
}

export default MusicItemError
